export default __webpack_public_path__ + "static/media/resume.4f0eff50.pdf";